export interface IRegisterUserPayload {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
}
export interface ILoginUserPayload {
  username: string;
  password: string;
}
export interface IAuthState {
  loading: boolean;
  userInfo: null | {}; // for user object
  userToken: null | string; // for storing the JWT
  error: null;
  success: boolean; // for monitoring the registration process.
}
export interface IInitialState {
  auth: IAuthState;
}
export interface IEvent {
  id: string;
  eventName: string;
  startDate: string;
  endDate: string;
  description: string;
}

export enum DashboardGraphViewType {
  Monthly = 1,
  Weekly = 2,
  Daily = 3,
}
